module.exports = __webpack_public_path__ + "img/wechat.d2c07718.png";